import React, { useState, useEffect } from "react";
import "../styles/SidebarMenu.css";

const testCaseOptions = {
  Desk: [
    "Appointment Booking",
    "Registration",
    "Appointment with age Details",
    "Bill After Appointment",
    "Sample Collection",
    "Result Entry",
    "Radiology List",
    "Technician Entry",
    "Doctor Notes",
    "Advanced Search",
    "kiosk",
    "Guest Check-in",
    "EMR",
    "Account Closing",
  ],
};

const SidebarMenu = ({ setSelection }) => {
  const [selectedTests, setSelectedTests] = useState([]);

  // Set all Desk tests as selected on mount
  useEffect(() => {
    const allTests = testCaseOptions.Desk || [];
    setSelectedTests(allTests);
    setSelection({
      platform: "Desk",
      tests: allTests,
    });
  }, [setSelection]);

  return (
    <div className="sidebar always-open">
      <div className="sidebar-header">
        <h3>Test Platform</h3>
      </div>

      <ul className="platform-list">
        <li className="active">DESK</li>
      </ul>

      <div className="testcase-list">
        <h4>Desk Test Cases</h4>

        {/* Select All (always selected + disabled) */}
        <label className="checkbox-label">
          <input type="checkbox" checked={true} disabled={true} />
          Select All
        </label>

        {/* Render all Desk test cases */}
        {selectedTests.map((test) => (
          <label key={`lab-${test}`} className="checkbox-label">
            <input type="checkbox" checked={true} disabled={true} />
            {test}
          </label>
        ))}
      </div>
    </div>
  );
};

export default SidebarMenu;
